import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { map, combineLatest, Observable } from 'rxjs';
import { Logger, PreviewMode, UtilityService } from 'src/app/@shared';
import { OfferProductService, Product, ProductDomain } from '../..';
import { AuthorizationService } from 'src/app/@shared/services/authorization.service';
import { CouponProductService } from '../../services/coupon-product.service';

const log = new Logger('CouponProductsCardsComponent');

@Component({
  selector: 'app-coupon-products-cards',
  templateUrl: './coupon-products-cards.component.html',
  styleUrls: ['./coupon-products-cards.component.scss'],
})

export class CouponProductsCardsComponent<T extends Product> implements OnInit, OnDestroy {
  viewModel$ = combineLatest([
    this.couponProductService.products$,
    this.couponProductService.isLoading$,
    this.couponProductService.totalRecords$,
    this.couponProductService.page$,
  ]).pipe(
    map(([products, isLoading, totalRecords, page]) => {
      if (products.length == 0 && page.pageIndex > 0) {
        this.couponProductService.resetpage();
        this.couponProductService.reload();
      }
      return { products, isLoading, totalRecords, page }
    }),
  );
  productsList: ProductDomain<Product>[] = [];
  selection = new SelectionModel<ProductDomain<Product>>(true, []);
  PreviewMode = PreviewMode;
  constructor(private couponProductService: CouponProductService<T>,
    private route: ActivatedRoute, public utilityService: UtilityService, private authorizationService: AuthorizationService){}

  ngOnInit(): void {
    log.debug('init');
    this.couponProductService.couponId = this.route.snapshot.params['couponId'];
    this.couponProductService.products$.subscribe((data) => {
      this.productsList = data;
    });

  }

  onImageError(event: Event): void {
    const element = event.target as HTMLImageElement;
    element.src = './assets/images/default-image.png'; // Path to your default image
  }

  ngOnDestroy() { }

  onSort(sortState: Sort): void {
    this.couponProductService.sort(sortState);
  }

  onPage(pageEvent: PageEvent): void {
    this.selection.clear();
    this.couponProductService.page(pageEvent);
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.productsList.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.productsList.forEach(row => this.selection.select(row));
  }

  public getSelectedSectionRecords() {
    return this.selection.selected;
  }

  public clearSelection() {
    this.selection.clear();
  }



  isAdmin(): boolean {
    const hasAccess = this.authorizationService.checkAccess('admin||offermang');
    return hasAccess;
  }
}
